import React from 'react';
import {
  Box,
  Button,
  CardContent,
  MenuItem,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tabs,
  Tab,
  Typography,
  Tooltip
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { format } from 'date-fns';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';
import SalesOrderView from './SalesOrderView';
import SalesLastInvoices from './SalesLastInvoice';
import InvoiceRequestPage from './InvoiceRequestPage';
import RegisterReturnPage from './RegisterReturnPage';

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function addZero(i) {
  if (i < 10) {
    i = '0' + i;
  }
  return i;
}

const deliveryTypes = [
  { iref: 9, name: 'All' },
  { iref: 0, name: 'Pickup' },
  { iref: 3, name: 'Glovo' },
  { iref: 4, name: 'Wolt' },
  { iref: 5, name: 'Bolt' }
];

const printTypes = [
  { iref: 9, name: 'All' },
  { iref: 0, name: 'False' },
  { iref: 1, name: 'True' }
];

const invoiceTypes = [
  { iref: 9, name: 'All' },
  { iref: 1, name: 'False' },
  { iref: 0, name: 'True' }
];

let d = new Date();
let today = format(d, 'yyyy-MM-dd');
let yesterday = format(new Date().setDate(new Date().getDate() - 1), 'yyyy-MM-dd');

const objectToCsv = function (data) {
  if (!data || data.length === 0) return '';

  const csvRows = [];
  const headers = Object.keys(data[0]);

  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header] === null || row[header] === undefined ? '' : row[header];
      return `"${String(val).replace(/"/g, '""')}"`;
    });

    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class OverviewOrders extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client('none'),
      saleslocation_list: [],
      tabValue: 'orders',
      page: 0,
      dtype: 9,
      dtypeName: 'All',
      invoiced: 9,
      invoicedName: 'All',
      printed: 9,
      printedName: 'All',
      rowsPerPage: 10,
      date: today,
      location: 0,
      locationName: 'All locations',
      sx_hidden: { display: 'none' },
      value: '1',
      locations: [],
      paytype: 9,
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addDate = this.addDate.bind(this);
    this.selectPeriod = this.selectPeriod.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.selectDelivery = this.selectDelivery.bind(this);
    this.selectPrinted = this.selectPrinted.bind(this);
    this.selectInvoiced = this.selectInvoiced.bind(this);
    this.selectPay = this.selectPay.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.queryData = {};
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let queryData = {
      location: this.state.location,
      date: this.state.date,
      dType: this.state.dtype,
      printed: this.state.printed,
      invoiced: this.state.invoiced,
      payType: this.state.paytype
    };

    let data = BackofficeReportsApi.getOrdersList(this.state.client, queryData);

    if (data) {
      this.setState({ orders_list: data });
    }

    this.setState({ filterData: queryData });

    let locations = BackofficeReportsApi.getLocations(this.state.client);

    if (locations && locations.locations) {
      this.setState({ locations: locations.locations });
    }
  }

  doSync() {
    this.getData();
    this.setState({ page: 0 });
  }

  addDate = event => {
    this.setState(
      { date: event.target.value },
      function () {
        this.doSync();
      }
    );
  };

  selectPeriod = event => {
    switch (event.target.value) {
      case 'today':
        this.setState(
          {
            sx_hidden: { display: 'none' },
            date: today
          },
          function () {
            this.doSync();
          }
        );
        break;

      case 'yesterday':
        this.setState(
          {
            sx_hidden: { display: 'none' },
            date: yesterday
          },
          function () {
            this.doSync();
          }
        );
        break;

      default:
        this.setState(
          { sx_hidden: {} },
          function () {
            this.doSync();
          }
        );
    }
  };

  selectLocation = event => {
    this.setState(
      {
        location: event.target.value,
        locationName: this.state.locations.find(o => o.iref === event.target.value)
      },
      function () {
        this.doSync();
      }
    );
  };

  selectPay = event => {
    this.setState(
      { paytype: event.target.value },
      function () {
        this.doSync();
      }
    );
  };

  selectDelivery = event => {
    this.setState(
      {
        dtype: event.target.value,
        dtypeName: deliveryTypes.find(o => o.iref === event.target.value)
      },
      function () {
        this.doSync();
      }
    );
  };

  selectPrinted = event => {
    this.setState(
      {
        printed: event.target.value,
        printedName: printTypes.find(o => o.iref === event.target.value)
      },
      function () {
        this.doSync();
      }
    );
  };

  selectInvoiced = event => {
    this.setState(
      {
        invoiced: event.target.value,
        invoicedName: invoiceTypes.find(o => o.iref === event.target.value)
      },
      function () {
        this.doSync();
      }
    );
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  };

  onDownload = () => {
    const locationName =
      this.state.locationName && this.state.locationName.name
        ? this.state.locationName.name
        : 'All locations';

    const deliveryName =
      this.state.dtypeName && this.state.dtypeName.name
        ? this.state.dtypeName.name
        : 'All';

    const link = document.createElement('a');
    link.download = 'ordersList_' + this.state.date + '_' + locationName + '.csv';

    let csvData = [];

    if (
      this.state.orders_list &&
      this.state.orders_list.result &&
      this.state.orders_list.result.length > 0
    ) {
      csvData = objectToCsv(this.state.orders_list.result);
    }

    let csvHeader =
      'Orders List\nDate: ' +
      this.state.date +
      '\nLocation: ' +
      locationName +
      '\nDelivery: ' +
      deliveryName;

    let csv = '\uFEFF' + csvHeader + '\n' + csvData;

    link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    link.click();
  };

  handleTabChange(event, newValue) {
    this.setState({ tabValue: newValue });
  }

  renderOrdersTab(locations, ordersList) {
    const bodyCellSx = {
      py: {
        xs: 0.55,
        sm: 0.75,
        md: 0.8
      },
      px: {
        xs: 0.35,
        sm: 0.65,
        md: 1
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontVariantNumeric: 'tabular-nums'
    };

    const headerCellSx = {
      py: {
        xs: 0.5,
        sm: 0.7,
        md: 0.85
      },
      px: {
        xs: 0.35,
        sm: 0.65,
        md: 1
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      lineHeight: 1.15,
      whiteSpace: 'normal',
      overflow: 'visible',
      textOverflow: 'clip'
    };

    const filterFieldSx = {
      '& .MuiInputBase-root': {
        height: 34,
        borderRadius: '12px',
        fontSize: {
          xs: '0.78rem',
          sm: '0.82rem'
        },
        bgcolor: '#fff'
      },
      '& .MuiInputLabel-root': {
        fontSize: {
          xs: '0.78rem',
          sm: '0.82rem'
        }
      }
    };

    return (
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            px: {
              xs: 0.75,
              sm: 1,
              md: 1.25
            },
            py: {
              xs: 0.65,
              sm: 0.75
            },
            flexShrink: 0,
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              mb: 0.75
            }}
          >
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography
                sx={{
                  color: '#1a237e',
                  fontWeight: 800,
                  fontSize: {
                    xs: '0.9rem',
                    sm: '1rem',
                    md: '1.05rem'
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                Orders Overview
              </Typography>

              <Typography
                sx={{
                  mt: 0.15,
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem'
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                Orders filtered by location, date and status
              </Typography>
            </Box>

            <Tooltip title="Download CSV">
              <Button
                size="small"
                onClick={this.onDownload}
                variant="contained"
                sx={{
                  minWidth: 36,
                  width: 36,
                  height: 36,
                  p: 0,
                  flexShrink: 0,
                  borderRadius: '12px',
                  color: '#1a237e',
                  bgcolor: 'rgba(26, 35, 126, 0.08)',
                  boxShadow: 'none',
                  border: '1px solid rgba(26, 35, 126, 0.12)',
                  '&:hover': {
                    bgcolor: 'rgba(26, 35, 126, 0.12)',
                    boxShadow: 'none'
                  }
                }}
              >
                <FileDownloadIcon fontSize="small" />
              </Button>
            </Tooltip>
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: {
                xs: 'flex-start',
                md: 'flex-end'
              },
              gap: 0.75,
              flexWrap: 'wrap',
              minWidth: 0
            }}
          >
            <TextField
              id="standard-select-location"
              select
              label="Location"
              defaultValue=""
              size="small"
              sx={{
                width: {
                  xs: 150,
                  sm: 170,
                  md: 190
                },
                flexShrink: 0,
                ...filterFieldSx
              }}
              onChange={this.selectLocation}
            >
              {locations.map(option => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="date"
              label="Date"
              type="date"
              size="small"
              value={this.state.date}
              sx={{
                width: {
                  xs: 126,
                  sm: 132
                },
                flexShrink: 0,
                ...filterFieldSx
              }}
              InputLabelProps={{
                shrink: true,
                sx: { color: '#5b5b5b' }
              }}
              InputProps={{
                sx: { color: '#5b5b5b' }
              }}
              inputProps={{
                min: '2024-01-01',
                style: {
                  color: '#5b5b5b',
                  paddingRight: 5,
                  paddingLeft: 5
                }
              }}
              onChange={this.addDate}
            />

            <TextField
              id="standard-select-dType"
              select
              label="Delivery"
              defaultValue="9"
              size="small"
              sx={{
                width: {
                  xs: 100,
                  sm: 110
                },
                flexShrink: 0,
                ...filterFieldSx
              }}
              onChange={this.selectDelivery}
            >
              {deliveryTypes.map(option => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-printed"
              select
              label="Printed"
              defaultValue="9"
              size="small"
              sx={{
                width: {
                  xs: 96,
                  sm: 106
                },
                flexShrink: 0,
                ...filterFieldSx
              }}
              onChange={this.selectPrinted}
            >
              {printTypes.map(option => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-invoiced"
              select
              label="Invoiced"
              defaultValue="9"
              size="small"
              sx={{
                width: {
                  xs: 104,
                  sm: 114
                },
                flexShrink: 0,
                ...filterFieldSx
              }}
              onChange={this.selectInvoiced}
            >
              {invoiceTypes.map(option => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-pay"
              select
              label="Paid"
              defaultValue="9"
              size="small"
              sx={{
                width: {
                  xs: 96,
                  sm: 106
                },
                flexShrink: 0,
                ...filterFieldSx
              }}
              onChange={this.selectPay}
            >
              <MenuItem value={9}>All</MenuItem>
              <MenuItem value={0}>Card</MenuItem>
              <MenuItem value={1}>Cash</MenuItem>
              <MenuItem value={2}>Credit</MenuItem>
              <MenuItem value={6}>Voucher</MenuItem>
            </TextField>
          </Box>
        </Box>

        <TableContainer
          sx={{
            flex: 1,
            minHeight: 0,
            overflowX: 'auto',
            overflowY: ordersList.length > 10 ? 'auto' : 'hidden',
            width: '100%',
            '& .MuiTableCell-root': {
              borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
              fontSize: {
                xs: '0.78rem',
                sm: '0.88rem',
                md: '0.92rem'
              }
            },
            '& .MuiTableRow-hover:hover': {
              backgroundColor: 'rgba(26, 35, 126, 0.035)'
            }
          }}
        >
          <Table
            stickyHeader
            size="small"
            aria-label="orders overview table"
            sx={{
              minWidth: {
                xs: 760,
                sm: 860,
                md: '100%'
              },
              width: '100%',
              tableLayout: 'fixed'
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    ...headerCellSx,
                    position: 'sticky',
                    left: 0,
                    zIndex: 4,
                    width: {
                      xs: 92,
                      sm: 110,
                      md: '13%'
                    }
                  }}
                >
                  OrderNo
                </TableCell>

                {[
                  ['Created', { xs: 82, sm: 90, md: '12%' }, 'center'],
                  ['Value', { xs: 92, sm: 110, md: '13%' }, 'right'],
                  ['ZNumber', { xs: 90, sm: 105, md: '13%' }, 'right'],
                  ['Receipt', { xs: 90, sm: 105, md: '13%' }, 'right'],
                  ['Payment', { xs: 150, sm: 180, md: '23%' }, 'right'],
                  ['Invoice', { xs: 100, sm: 120, md: '13%' }, 'right']
                ].map(([label, width, align]) => (
                  <TableCell
                    key={label}
                    align={align}
                    sx={{
                      ...headerCellSx,
                      width
                    }}
                  >
                    {label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {(this.state.rowsPerPage > 0
                ? ordersList.slice(
                    this.state.page * this.state.rowsPerPage,
                    this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                  )
                : ordersList
              ).map(order => {
                return (
                  <TableRow hover key={order.id} tabIndex={-1}>
                    <TableCell
                      sx={{
                        py: {
                          xs: 0.55,
                          sm: 0.75,
                          md: 0.8
                        },
                        px: {
                          xs: 0.35,
                          sm: 0.65,
                          md: 1
                        },
                        position: 'sticky',
                        left: 0,
                        zIndex: 2,
                        bgcolor: '#fff',
                        whiteSpace: 'nowrap',
                        color: '#111827',
                        fontWeight: 550,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: {
                          xs: 92,
                          sm: 110,
                          md: '13%'
                        }
                      }}
                    >
                      {order.id}
                    </TableCell>

                    <TableCell align="center" sx={bodyCellSx}>
                      {addZero(order.createdOn.getHours()) + ':' + addZero(order.createdOn.getMinutes())}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {order.value}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {order.ZNumber}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {order.receiptNumber}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {order.transaction}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {order.invoiceNo}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, { value: -1, label: 'All' }]}
          labelRowsPerPage="Rows:"
          component="div"
          count={ordersList.length}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          sx={{
            flexShrink: 0,
            borderTop: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: '#fff',
            minHeight: {
              xs: 44,
              sm: 52
            },
            overflow: 'hidden',
            '& .MuiTablePagination-toolbar': {
              minHeight: {
                xs: 44,
                sm: 52
              },
              px: {
                xs: 0.5,
                sm: 1
              },
              flexWrap: {
                xs: 'wrap',
                sm: 'nowrap'
              },
              gap: {
                xs: 0.25,
                sm: 0.5
              }
            },
            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
              fontSize: {
                xs: '0.88rem',
                sm: '0.92rem',
                md: '1rem'
              },
              m: 0
            },
            '& .MuiTablePagination-actions': {
              ml: {
                xs: 0,
                sm: 1
              }
            }
          }}
        />
      </Box>
    );
  }

  renderTabContent(locations, ordersList) {
    if (this.state.tabValue === 'orders') {
      return this.renderOrdersTab(locations, ordersList);
    }

    return (
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          '& > *': {
            flex: 1,
            minHeight: 0,
            overflow: 'hidden'
          }
        }}
      >
        {this.state.tabValue === 'view' && <SalesOrderView />}
        {this.state.tabValue === 'invoice' && <SalesLastInvoices />}
        {this.state.tabValue === 'generate' && <InvoiceRequestPage />}
        {this.state.tabValue === 'return' && <RegisterReturnPage />}
      </Box>
    );
  }

  render() {
    let locations = [];

    if (this.state.locations) {
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];

        let myData = {
          iref: fData.iref,
          name: fData.name
        };

        locations.push(myData);
      });
    }

    let ordersList = [];

    if (this.state.orders_list) {
      if (this.state.orders_list.result) {
        Object.keys(this.state.orders_list.result).forEach(key => {
          let fData = this.state.orders_list.result[key];

          let p = {
            id: fData.iref,
            location: fData.pos__location__name,
            ZNumber: fData.ZNumber,
            receiptNumber: fData.receiptNumber,
            createdOn: new Date(fData.createdOn),
            invoiceNo: fData.invoice__serial,
            value: thousandsSeparator(parseInt(fData.totalAmount || 0)),
            transaction: Array.isArray(fData.transaction) ? fData.transaction.join(', ') : ''
          };

          ordersList.push(p);
        });
      }
    }

    return (
      <CardContent
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          maxHeight: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          minHeight: 0,
          boxSizing: 'border-box',
          p: '0 !important',
          borderRadius: {
            xs: '14px',
            sm: '16px'
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff'
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: '#fff',
            px: {
              xs: 0.5,
              sm: 0.75
            }
          }}
        >
          <Tabs
            value={this.state.tabValue}
            onChange={this.handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            indicatorColor="secondary"
            sx={{
              minHeight: 42,
              '& .MuiTab-root': {
                minHeight: 42,
                maxHeight: 42,
                px: {
                  xs: 1,
                  sm: 1.25
                },
                fontSize: {
                  xs: '0.76rem',
                  sm: '0.82rem'
                },
                fontWeight: 750,
                textTransform: 'none',
                color: '#64748b'
              },
              '& .Mui-selected': {
                color: '#1a237e !important'
              }
            }}
          >
            <Tab label="Orders" value="orders" />
            <Tab label="Detail" value="view" />
            <Tab label="Invoices" value="invoice" />
            <Tab label="Create Inv." value="generate" />
            <Tab label="Return" value="return" />
          </Tabs>
        </Box>

        {this.renderTabContent(locations, ordersList)}
      </CardContent>
    );
  }
}

export default OverviewOrders;
